// Extended editorial detail data keyed by event id.
// Merged into base EVENTS record on the detail page.

const GALLERY_POOL = {
  ballroom: [
    "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1533900298318-6b8da08a523e?auto=format&fit=crop&w=1600&q=80",
  ],
  country: [
    "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1518631286012-51ea0d1c8b7d?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1533450718592-29d45c07cc0c?auto=format&fit=crop&w=1600&q=80",
  ],
  awards: [
    "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1573497491765-dccce02b29df?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1600&q=80",
  ],
};

export const EVENT_DETAILS = {
  "chain-of-hope-gala-ball": {
    dressCode: "Black Tie",
    capacity: "520 guests",
    tickets: [
      { tier: "Individual Seat", price: "£395" },
      { tier: "Table of Ten", price: "£3,750" },
      { tier: "Benefactor's Table", price: "£9,500" },
    ],
    description: [
      "Chain of Hope opens the doors of the Natural History Museum for a single evening each November, dining beneath the great blue whale of Hintze Hall in aid of children's cardiac care in the world's poorest countries.",
      "A champagne reception among the galleries, a three-course dinner beneath the whale, a live auction of rare experiences, and dancing until late. Founded by Professor Sir Magdi Yacoub, the charity has treated children in over thirty countries.",
    ],
    programme: [
      { time: "19:00", title: "Champagne in Hintze Hall" },
      { time: "20:00", title: "Dinner beneath the Whale" },
      { time: "21:30", title: "Address & Live Auction" },
      { time: "22:30", title: "Dancing" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "Chain of Hope, founded in 1995 by Professor Sir Magdi Yacoub, provides life-saving cardiac treatment to children in developing and war-torn countries. Its gala at the Natural History Museum is among the most anticipated charity evenings of the London winter.",
    address: {
      venue: "Natural History Museum",
      street: "Cromwell Road",
      city: "South Kensington, London SW7 5BD",
      note: "Guests enter via the Cromwell Road steps. Black-cab drop-off is on Cromwell Road.",
    },
    gallery: GALLERY_POOL.ballroom,
    year: "XXXI",
  },
  "the-macmillan-ball": {
    dressCode: "Black Tie",
    capacity: "400 seated",
    tickets: [
      { tier: "Individual Seat", price: "£250" },
      { tier: "Table of Ten", price: "£2,400" },
      { tier: "Patrons' Table", price: "£6,000" },
    ],
    description: [
      "The Macmillan Ball is London's most generous winter evening - a black-tie dinner and auction in aid of Macmillan Cancer Support, held each December in the ballroom of The Dorchester.",
      "Champagne on the Promenade, dinner by the hotel's kitchens, an address from a Macmillan nurse, and an auction that has, in recent years, become quietly legendary for its generosity. Dancing follows until one.",
    ],
    programme: [
      { time: "19:00", title: "Reception on the Promenade" },
      { time: "20:00", title: "Dinner in the Ballroom" },
      { time: "21:30", title: "A Nurse's Address" },
      { time: "22:00", title: "The Auction" },
      { time: "22:45", title: "Dancing" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "Macmillan Cancer Support has, since 1911, stood beside people living with cancer across the United Kingdom. The Macmillan Ball is its flagship London fundraising evening, underwriting the charity's network of specialist nurses.",
    address: {
      venue: "The Dorchester",
      street: "53 Park Lane",
      city: "Mayfair, London W1K 1QA",
      note: "Please arrive via the Park Lane entrance. Valet parking is available to Patrons' Tables.",
    },
    gallery: GALLERY_POOL.ballroom,
    year: "XXVIII",
  },
  "glasgow-business-awards": {
    dressCode: "Black Tie",
    capacity: "650 guests",
    tickets: [
      { tier: "Individual Seat", price: "£145" },
      { tier: "Table of Ten", price: "£1,350" },
      { tier: "Prime Table", price: "£2,200" },
    ],
    description: [
      "The Glasgow Business Awards are the Glasgow Chamber of Commerce's flagship ceremony, honouring the enterprise of the city - from the shipyards of the Clyde to the software houses of the Merchant City.",
      "A champagne reception in the Grand Central's marble hall, dinner beneath the glass canopy, and awards across fourteen categories. Proceeds support the Chamber's apprenticeship and enterprise programmes.",
    ],
    programme: [
      { time: "18:30", title: "Reception in the Marble Hall" },
      { time: "19:30", title: "Dinner under the Glass Canopy" },
      { time: "21:00", title: "The Awards Ceremony" },
      { time: "22:30", title: "Address - The Lord Provost" },
      { time: "23:00", title: "Dancing" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "Glasgow Chamber of Commerce, founded in 1783, is the oldest chamber of commerce in the English-speaking world. Its Business Awards are the highlight of the city's commercial calendar.",
    address: {
      venue: "The Grand Central Hotel",
      street: "99 Gordon Street",
      city: "Glasgow G1 3SF",
      note: "The hotel adjoins Glasgow Central station. Discounted rooms are held for guests on the night of the ceremony.",
    },
    gallery: GALLERY_POOL.awards,
    year: "XLI",
  },
  "midnight-in-mayfair": {
    dressCode: "Black Tie",
    capacity: "220 seated",
    tickets: [
      { tier: "Individual Seat", price: "£480" },
      { tier: "Table of Ten", price: "£4,600" },
      { tier: "Patrons' Table", price: "£12,000" },
    ],
    description: [
      "In its ninth year, Midnight in Mayfair remains one of the quieter fixtures of the February calendar - a valentine gala held on a single night, in a single ballroom, in aid of one cause.",
      "Guests are received at nine in the Dorchester's Promenade under a canopy of white peonies. Dinner is announced at ten. Champagne is Louis Roederer 2015. Coffee is at one, and by two the ballroom is empty. There is no leaderboard. There is no live auction. There is a paddle raise, and it is understood.",
    ],
    programme: [
      { time: "20:30", title: "Reception & Louis Roederer" },
      { time: "21:30", title: "Dinner by Alain Ducasse" },
      { time: "22:45", title: "Address - Prof. Amelia Grover" },
      { time: "23:15", title: "The Paddle Raise" },
      { time: "00:00", title: "Midnight - dance floor opens" },
      { time: "02:00", title: "Carriages" },
    ],
    hostBio:
      "The Serpentine Foundation has, since 2003, funded 41 paediatric oncology research fellowships across the United Kingdom. In 2025 its combined grant book stood at £48m. The Foundation publishes no annual gala photograph; its patrons prefer it that way.",
    address: {
      venue: "The Dorchester",
      street: "53 Park Lane",
      city: "Mayfair, London W1K 1QA",
      note: "Please arrive via the Park Lane entrance. Valet parking is available to Patrons' Tables.",
    },
    gallery: GALLERY_POOL.ballroom,
    year: "IX",
  },
  "aurum-night": {
    dressCode: "Black Tie",
    capacity: "180 seated",
    tickets: [
      { tier: "Individual Seat", price: "£360" },
      { tier: "Table of Eight", price: "£2,700" },
      { tier: "Silent Bid Card", price: "£120 + entry" },
    ],
    description: [
      "Aurum Night is the Aurum Trust's annual evening of amber-tinted champagne and quieter conversation, held each March in Claridge's Ballroom.",
      "The evening's rhythm is a familiar one: a champagne reception, a five-course dinner by Simon Rogan, three speeches (none longer than eight minutes), and a silent auction of experiences never listed on any other paper.",
    ],
    programme: [
      { time: "19:00", title: "Champagne on the Foyer" },
      { time: "20:00", title: "Dinner by Simon Rogan" },
      { time: "21:30", title: "The Silent Auction closes" },
      { time: "22:00", title: "Address - The Chair" },
      { time: "22:30", title: "Music & carriages by 01:00" },
    ],
    hostBio:
      "The Aurum Trust supports British craftsmanship - silversmithing, restoration, luthiery, and the last four working shirt-makers on Jermyn Street. Its endowment sat at £22m at the close of 2025.",
    address: {
      venue: "Claridge's",
      street: "Brook Street",
      city: "Mayfair, London W1K 4HR",
      note: "The Ballroom entrance is via Davies Street.",
    },
    gallery: GALLERY_POOL.ballroom,
    year: "XII",
  },
  "the-highgrove-ball": {
    dressCode: "Black Tie · Long Gowns",
    capacity: "160 seated",
    tickets: [
      { tier: "By invitation only", price: "-" },
    ],
    description: [
      "The Highgrove Ball is an evening held in the private gardens of Highgrove House, under white marquee, in aid of the King's Foundation for heritage crafts and rural livelihoods.",
      "The evening is invitation-only and unphotographed. Guests are asked to arrive in daylight. Music is provided by a live twelve-piece string ensemble. Dinner is grown, in the main, within a mile of the marquee.",
    ],
    programme: [
      { time: "18:30", title: "Garden walk with the Head Gardener" },
      { time: "19:30", title: "Reception on the West Lawn" },
      { time: "20:30", title: "Dinner in the Marquee" },
      { time: "22:00", title: "Address - HRH The King's Representative" },
      { time: "22:30", title: "Dancing under the Cedar" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "The King's Foundation, founded in 1990, has trained over 15,000 craftspeople in traditional building, textile and land skills. Highgrove House has hosted this ball annually since 2019.",
    address: {
      venue: "Highgrove House",
      street: "Doughton",
      city: "Tetbury, Gloucestershire GL8 8TN",
      note: "Guests are met at Kemble station by private car; arrival details are issued with the invitation.",
    },
    gallery: GALLERY_POOL.country,
    year: "VII",
  },
  "the-tusk-ball": {
    dressCode: "Black Tie",
    capacity: "500 guests",
    tickets: [
      { tier: "Individual Seat", price: "£500" },
      { tier: "Table of Ten", price: "£4,800" },
      { tier: "Sponsorship Packages", price: "On Request" },
    ],
    description: [
      "The Marquess and Marchioness of Bath open the East Terrace of Longleat for one evening only, in aid of Tusk and to mark the sixtieth anniversary of Longleat Safari Park.",
      "Guests arrive at seven for a champagne reception overlooking the Half Mile Pond, in view of the Icons of the Sky Festival. Dinner is served in the Great Hall beneath the Renaissance ceilings. Auction, entertainment, and dancing follow - with sleighs and carriages by one.",
    ],
    programme: [
      { time: "19:00", title: "Champagne on the East Terrace" },
      { time: "20:00", title: "Icons of the Sky - festival viewing" },
      { time: "20:30", title: "Dinner in the Great Hall" },
      { time: "22:00", title: "Entertainment & Auction" },
      { time: "23:00", title: "Dancing" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "Tusk has, since 1990, protected Africa's wildlife and supported the communities that live alongside it. This year's ball is hosted by The Marquess and Marchioness of Bath from Longleat, whose family, in 1966, opened the first drive-through safari park outside Africa.",
    address: {
      venue: "Longleat House",
      street: "The Longleat Estate",
      city: "Warminster, Wiltshire BA12 7NW",
      note:
        "To reserve a table or purchase tickets, please write to adele@tusk.org. Sponsorship packages available on request.",
    },
    gallery: GALLERY_POOL.country,
    year: "MMXXVI",
  },
  "the-city-honours": {
    dressCode: "Black Tie",
    capacity: "540 seated",
    tickets: [
      { tier: "Individual Seat", price: "£520" },
      { tier: "Table of Ten", price: "£4,900" },
      { tier: "Prime Table", price: "£7,800" },
    ],
    description: [
      "The City Honours is the London Chamber's annual ceremony recognising the year's most consequential UK deal-makers - venture, restructuring, M&A and infrastructure.",
      "The evening is held under the Guildhall's medieval hammer-beam roof. Awards are announced in nine categories. No sponsor logos are projected during dinner; sponsors are named in the programme, once, and never again.",
    ],
    programme: [
      { time: "18:30", title: "Reception in the Old Library" },
      { time: "19:30", title: "Dinner - Great Hall" },
      { time: "21:00", title: "Awards Ceremony" },
      { time: "22:30", title: "Address - The Lord Mayor" },
      { time: "23:00", title: "Dancing in the Crypt" },
      { time: "01:30", title: "Carriages" },
    ],
    hostBio:
      "The London Chamber of Commerce has hosted The City Honours annually since 1978. Proceeds from patrons' tables fund the LCC apprenticeship endowment.",
    address: {
      venue: "The Guildhall",
      street: "Gresham Street",
      city: "City of London EC2V 7HH",
      note: "Please enter via the Aldermanbury gate. Black-cab drop-off is on Gresham Street.",
    },
    gallery: GALLERY_POOL.awards,
    year: "XLVIII",
  },
  "north-star-awards": {
    dressCode: "Black Tie",
    capacity: "420 seated",
    tickets: [
      { tier: "Individual Seat", price: "£295" },
      { tier: "Table of Ten", price: "£2,800" },
    ],
    description: [
      "The North Star Awards are Ulster Business's flagship ceremony, held annually in the double-height galleries of Titanic Belfast.",
      "The evening honours enterprises built in Northern Ireland - from the shipyard cranes at Harland to the software houses of the Cathedral Quarter. Winners are announced across twelve categories.",
    ],
    programme: [
      { time: "18:30", title: "Champagne on the Slipway" },
      { time: "19:15", title: "Dinner in Gallery One" },
      { time: "20:45", title: "The North Star Awards" },
      { time: "22:15", title: "Address - First Minister's Office" },
      { time: "22:45", title: "Dancing" },
      { time: "01:00", title: "Carriages" },
    ],
    hostBio:
      "Ulster Business has covered the Northern Ireland economy since 1988. The North Star Awards were established in 2004 to spotlight the province's most enterprising firms and founders.",
    address: {
      venue: "Titanic Belfast",
      street: "1 Olympic Way",
      city: "Belfast BT3 9EP",
      note: "Complimentary parking is available on-site. The Great Light installation is illuminated for guests until 21:00.",
    },
    gallery: GALLERY_POOL.awards,
    year: "XXII",
  },
  "bafta-scotland-awards": {
    dressCode: "Black Tie",
    capacity: "600 guests",
    tickets: [
      { tier: "Individual Seat", price: "£310" },
      { tier: "Table of Ten", price: "£2,950" },
      { tier: "Prime Table", price: "£4,800" },
    ],
    description: [
      "BAFTA Scotland's annual awards close the Scottish creative calendar, honouring the year's finest work across film, television and games - from Glasgow's newest studios to feature debuts written in the Hebrides.",
      "The ceremony is announced across thirteen categories. Reception opens in the Glasgow Ballroom at half past six. Dinner follows the presentation. A late-night reception continues in the Cathedral Suite.",
    ],
    programme: [
      { time: "18:30", title: "Champagne Reception" },
      { time: "19:30", title: "The Ceremony" },
      { time: "21:30", title: "Dinner in the Ballroom" },
      { time: "23:00", title: "After-Party - Cathedral Suite" },
      { time: "01:30", title: "Carriages" },
    ],
    hostBio:
      "BAFTA Scotland has, since 1988, championed the country's screen industries - from Bill Forsyth to Lynne Ramsay, from Grand Theft Auto to Outlander. Its awards remain the most watched black-tie evening in the Scottish creative calendar.",
    address: {
      venue: "DoubleTree by Hilton Glasgow Central",
      street: "36 Cambridge Street",
      city: "Glasgow G2 3HN",
      note:
        "Guests are asked to arrive by 18:15. Complimentary cloakroom is provided; overnight accommodation is available at the DoubleTree at member rate.",
    },
    gallery: GALLERY_POOL.awards,
    year: "XXXVIII",
  },
  "james-watt-dinner": {
    dressCode: "Black Tie",
    capacity: "300 guests",
    tickets: [
      { tier: "Individual Seat", price: "£95" },
      { tier: "Member's Seat", price: "£75" },
      { tier: "Student Place (sponsored)", price: "£50" },
    ],
    description: [
      "The James Watt Dinner is one of the oldest engineering dinners in the world, held each October in Glasgow in celebration of James Watt - and of the engineers inducted, that same evening, into the Scottish Engineering Hall of Fame.",
      "A glass of something sparkling on arrival, a three-course dinner, a dram raised to Watt in the Immortal Memory toast, and musicians from the Royal Conservatoire of Scotland. Small parties, large parties, and individuals are all warmly received.",
    ],
    programme: [
      { time: "18:15", title: "Reception - a glass on arrival" },
      { time: "19:00", title: "Dinner is served" },
      { time: "20:30", title: "The Immortal Memory - a dram to Watt" },
      { time: "21:00", title: "Hall of Fame Inductions" },
      { time: "21:45", title: "Music & networking" },
      { time: "23:00", title: "Carriages" },
    ],
    hostBio:
      "The Institution of Engineers and Shipbuilders in Scotland (IESIS), founded in 1857, is among the oldest engineering institutions in the world. The James Watt Dinner is its flagship evening, and the occasion of the Scottish Engineering Hall of Fame inductions.",
    address: {
      venue: "Radisson Blu Hotel",
      street: "301 Argyle Street",
      city: "Glasgow G2 8DL",
      note:
        "Discounted rooms are held under code JWD26. To book, write to secretary@engineers.scot or reserve via the Institution's Eventbrite.",
    },
    gallery: GALLERY_POOL.awards,
    year: "CLXVIII",
  },
  "argyllshire-gathering-ball": {
    dressCode: "Highland Dress · White Tie",
    capacity: "400 seated",
    tickets: [
      { tier: "Individual Seat", price: "£245" },
      { tier: "Table of Ten", price: "£2,300" },
      { tier: "Chieftain's Table", price: "£3,900" },
    ],
    description: [
      "Since 1871, the Argyllshire Gathering has closed the Highland Games season with a single formal evening in Oban - piping competitions by day, reeling and long-table dinner by night, in Highland dress and white tie.",
      "The Ball is preceded by the Silver Chanter and Gold Medal piping. Guests dress by seven. Dinner is announced by pipe. Reels are called by a Master of the Gathering. A Highland breakfast is served at one, and the ballroom is empty by two.",
    ],
    programme: [
      { time: "19:00", title: "Reception on the Esplanade" },
      { time: "20:00", title: "Grand Entrance & Address" },
      { time: "20:30", title: "The Long-Table Dinner" },
      { time: "22:00", title: "Highland Reeling begins" },
      { time: "01:00", title: "Auld Lang Syne" },
      { time: "01:30", title: "Carriages" },
    ],
    hostBio:
      "The Argyllshire Gathering has been in continuous residence at Oban since 1871. Alongside the piping competitions for the Silver Chanter and the Gold Medal, the Gathering Ball is one of the fixed points of the Scottish social calendar.",
    address: {
      venue: "Corran Halls",
      street: "Corran Esplanade",
      city: "Oban, Argyll PA34 5AB",
      note:
        "Highland dress is expected; a small number of hire kilts are available through the Gathering's office. Overnight accommodation at the Perle Hotel is arranged at member rate.",
    },
    gallery: GALLERY_POOL.country,
    year: "CLV",
  },
  "northern-meeting-ball": {
    dressCode: "Highland Dress · White Tie",
    capacity: "350 seated",
    tickets: [
      { tier: "Individual Seat", price: "£280" },
      { tier: "Table of Ten", price: "£2,650" },
      { tier: "Two-Night Pass", price: "£520" },
    ],
    description: [
      "Founded in 1788, the Northern Meeting is Scotland's oldest continuous social gathering - held each September in the Northern Meeting Rooms at Inverness, and traditionally observed as a two-night ball.",
      "Guests are received at seven for the Grand March and the Piper's Address. Dinner is served by candlelight. Reeling continues until two, and the second evening's programme carries on largely without editorial change since the Regency.",
    ],
    programme: [
      { time: "19:00", title: "Reception in the Ballroom" },
      { time: "20:00", title: "Grand March & Piper's Address" },
      { time: "20:30", title: "Dinner by Candlelight" },
      { time: "22:15", title: "Highland Reeling" },
      { time: "01:30", title: "Auld Lang Syne · Carriages" },
    ],
    hostBio:
      "The Northern Meeting has convened annually in Inverness since 1788, making it the oldest continuous social meeting in Scotland. The ball is traditionally held over two consecutive evenings; the programme has been altered only twice in two centuries.",
    address: {
      venue: "The Northern Meeting Rooms",
      street: "Ardross Street",
      city: "Inverness IV3 5DL",
      note:
        "Highland dress is required. The Committee arranges overnight accommodation at Culloden House and Rocpool Reserve for guests travelling from beyond Perthshire.",
    },
    gallery: GALLERY_POOL.country,
    year: "CCXXXVIII",
  },
  "beaufort-ball": {
    dressCode: "White Tie",
    capacity: "340 seated",
    tickets: [
      { tier: "Individual Seat", price: "£340" },
      { tier: "Table of Ten", price: "£3,200" },
      { tier: "Ducal Table", price: "£8,500" },
    ],
    description: [
      "Held every third year in the state rooms of Badminton House, the Beaufort Ball is white-tie, cellar-first, and remarkably discreet.",
      "Silver is polished. The candelabra number eighty-four. The Duke's cellar is opened once during the evening, and closed once. Dinner is announced by a footman. Dancing is announced by the Master.",
    ],
    programme: [
      { time: "19:30", title: "Champagne in the Great Hall" },
      { time: "20:30", title: "Dinner in the State Dining Room" },
      { time: "22:30", title: "Address - The Duke" },
      { time: "22:45", title: "Cellar opened" },
      { time: "23:15", title: "The Ball begins" },
      { time: "03:00", title: "Carriages" },
    ],
    hostBio:
      "The Beaufort has been resident at Badminton since 1682. Its Ball, held triennially, is by tradition the most formal country evening of the British calendar.",
    address: {
      venue: "Badminton House",
      street: "Badminton",
      city: "Gloucestershire GL9 1DB",
      note: "Guests are met at Chippenham station by private car; overnight accommodation is arranged in Badminton Village.",
    },
    gallery: GALLERY_POOL.country,
    year: "MMXXVI",
  },
  "cottesmore-ball-DEPRECATED": null,
};

export const getEventDetail = (id) => EVENT_DETAILS[id] || null;
